import {constants} from "../../common/constants/constants";

/**
 * @typedef {object} ApartmentRates
 * @property {number} january
 * @property {number} february
 * @property {number} march
 * @property {number} april
 * @property {number} may
 * @property {number} june
 * @property {number} july
 * @property {number} august
 * @property {number} september
 * @property {number} october
 * @property {number} november
 * @property {number} december
 * */


/**
 * @typedef {{ [apartmentNumber: string]: ApartmentRates }} RatesData
 * */

export class UpdateRatesData {

    /** @type {RatesData}  */ #rates = {};
    /** @type {Object}  */ #feeDifferences;

    /**
     * @param {RatesData} data
     * */
    * #getRatesDataIterator(data) {
        for (const [apartmentNumber, rates] of Object.entries(data)) {
            for (let i = 1, max = 13; i < max; i++) {
                const month = constants.MonthsToText[i];
                const amount = rates[month];
                if (amount != null) {
                    yield { month, amount, apartmentNumber };
                }
            }
        }

    }

    /**
     * @param {RatesData} data
     * */
    addRates(data) {
        for (const { month, amount, apartmentNumber } of this.#getRatesDataIterator(data)) {
            this.#rates[apartmentNumber] ??= {};
            this.#rates[apartmentNumber][month] = (this.#rates[apartmentNumber][month] ?? 0) + amount;
        }
    }

    /**
     * @param {RatesData} data
     * */
    setRates(data) {
        /*Subtraction fee due to bug https://bllink.atlassian.net/browse/SSB-1005*/
        for (const { month, amount, apartmentNumber } of this.#getRatesDataIterator(data)) {
            this.#rates[apartmentNumber] ??= {};
            const previousAmount = (this.#rates[apartmentNumber][month] ?? 0);
            if (this.#feeDifferences?.[apartmentNumber]?.[month]){
                this.#feeDifferences[apartmentNumber][month]-= previousAmount;
            }
            this.#rates[apartmentNumber][month] = amount;
        }
    }

    setFeeDifferences(userRates) {
        this.#feeDifferences = {...userRates};
    }
    toJSON() {
        const rows = [
            // static header imitate excel table header
            {
                "פרטי דיירים":"שם דייר",
                "__EMPTY":"מספר דירה",
                "__EMPTY_1":"טלפון נייד",
                "__EMPTY_2":"כתובת מייל",
                "__EMPTY_3":"ינואר ",
                "__EMPTY_4":"פברואר",
                "__EMPTY_5":"מרץ",
                "__EMPTY_6":"אפריל",
                "__EMPTY_7":"מאי",
                "__EMPTY_8":"יוני",
                "__EMPTY_9":"יולי",
                "__EMPTY_10":"אוגוסט",
                "__EMPTY_11":"ספטמבר",
                "__EMPTY_12":"אוקטובר",
                "__EMPTY_13":"נובמבר",
                "__EMPTY_14":"דצמבר"
            }
        ];
        for (const [apartmentNumber, rates] of Object.entries(this.#rates)) {
            rows.push({
                '__EMPTY': apartmentNumber,
                '__EMPTY_3': rates.january,
                '__EMPTY_4': rates.february,
                '__EMPTY_5': rates.march,
                '__EMPTY_6': rates.april,
                '__EMPTY_7': rates.may,
                '__EMPTY_8': rates.june,
                '__EMPTY_9': rates.july,
                '__EMPTY_10': rates.august,
                '__EMPTY_11': rates.september,
                '__EMPTY_12': rates.october,
                '__EMPTY_13': rates.november,
                '__EMPTY_14': rates.december,
            });
        }
        return this.#feeDifferences ? {rows, feeDifferences: this.#feeDifferences} : rows;
    }

}
